import api from "../Api/feathers-client";
import { spread, union, concat } from "lodash";
import axios from "axios";
import worker_script from "./mp3Worker";
import packageJson from "../../package.json";
import Store from "../Store";

// Array for School Hierarchy Class names list
var classNames = [];

// Call backend service to get selected defs
export const getDefsByKeyId = async (keyId, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("defs").find({
        query: {
          keyid: keyId,
          site_uuid: site_uuid,
        },
      });

      resolve({
        status: 200,
        message: "All Defs By KeyId",
        data: response["data"][0],
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Recursive function to get leaf node data
const manipulateJson = (jsn, name) => {
  for (let i = 0; i < jsn.length; i++) {
    if (jsn[i].isClass == false) {
      let nm = name + "-" + jsn[i].value;
      manipulateJson(jsn[i].children, nm);
    } else {
      let cname = name + "-" + jsn[i].value;
      let str = cname.split("-");
      let nm = "";
      for (let j = 2; j < str.length - 1; j++) {
        nm = nm + str[j] + "-";
      }
      nm = nm + str[str.length - 1];
      let obj = {};
      obj.id = jsn[i].id;
      obj.value = "" + nm + "";
      classNames.push(obj);
    }
  }
};

// Return final classes list of school hierarchy
export const getClassNames = (site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let defsData = await getDefsByKeyId("class_hierarchy", site_uuid);
      classNames = [];
      manipulateJson(defsData["data"]["keydata"]["children"], "");
      resolve(classNames);
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to insert logs
export const userLogs = async (data) => {
  if (data.hasOwnProperty("site_uuid") && data.site_uuid == "") return;

  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").create(
        {
          ...data,
          outcome: {
            ...data.outcome,
            deviceType: "web",
            applicationVersion: packageJson.version,
          },
        },
        {}
      );

      resolve({
        status: 200,
        message: "User-log Created",
        data: response,
      });
    } catch (error) {
      resolve({
        status: 500,
        message: "something wrong!",
        data: error,
      });
    }
  });
};

// fetch user logs data
export const getUserLogs = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find(params);
      resolve({
        status: 200,
        message: "User logs data",
        data: response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

// Final Duration Calculation
export const durationCalculate = (duration, startTime) => {
  let dateObj = new Date();
  var finalDuration = 0;
  if (startTime != 0) {
    finalDuration = +dateObj.getTime() - +startTime + Number(duration);
  }

  return finalDuration;
};

// Upload media
//   export const uploadFile = async (file, userid) => {
//     return new Promise(async (resolve, reject) => {
//       try {
//         let response = await api.service("uploads").create(
//           {
//             type: "mediaTask",
//             uri: file,
//             user_id: userid,
//           },
//           {}
//         );

//         resolve({
//           status: 200,
//           message: "User-log Created",
//           data: response,
//         });
//       } catch (error) {
//         resolve(error);
//       }
//     });
//   };

// Call backend service to get asset
export const getAsset = async (assetUid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assets").find({
        query: {
          $select: ["content"],
          asset_uid: assetUid,
        },
      });

      resolve({
        status: 200,
        message: "Asset Data",
        data: response.data,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const unicodeToString = (theString) => {
  if (theString != undefined) {
    return theString.replace(/\\u[\dA-F]{4}/gi, (match) => {
      return String.fromCharCode(parseInt(match.replace(/\\u/g, ""), 16));
    });
  }
};

export const concatAllArrays = spread(union);

export const concatAllArraysWithDuplicate = spread(concat);

export const shuffle = (array) => {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};

export const dynamicSort = (property) => {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
};

export const joinByKeys = (obj = {}, props = [], separator = "") => {
  // empty array.
  let arr = [];
  // push props to array
  props.forEach((p) => arr.push(obj[p]));
  // return the joined array.
  return arr.join(separator);
};

export const hhmmssToMilli = (hms) => {
  var time = hms.split(":"); // split it at the colons
  var seconds = time[2].split(".");
  var milliseconds = 0;
  if (seconds.length > 1) {
    milliseconds = +time[0] * 60 * 60 + +time[1] * 60 + +seconds[0];
    milliseconds = +milliseconds * 1000 + +seconds[1];
  } else {
    milliseconds = +time[0] * 60 * 60 + +time[1] * 60 + +seconds[0];
    milliseconds = +milliseconds * 1000;
  }

  return milliseconds;
};

// Call backend service to get words
export const getWords = async (wordIds) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("get-words").find({
        query: {
          word_uids: wordIds,
        },
      });

      resolve({
        status: 200,
        message: "Word Data",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const audioSmartCheck = async (
  blob,
  textToCheck,
  isUpload = false,
  user_id = null,
  site_uuid
) => {
  const options = {
    headers: {
      Authorization:
        "ELSA DX+gsaRdJgTQN7K3XtShZ5b6x/KnAn7pa7QPf777QVE3phJ46PtdcvN2mGSo5p9YM7JzUOf4idcnCvqwgqaIKHsNmurW+1gfLwv+pZtxBxc=",
    },
    maxContentLength: 100000000,
    maxBodyLength: 1000000000,
  };
  let filename;

  return new Promise(async (resolve, reject) => {
    try {
      const content = await blobToBase64(blob);
      console.log("content", content);

      var data = new FormData();
      data.append("audio_data", content.split("base64,")[1]);
      data.append("sentence", textToCheck);
      data.append("api_plan", "standard");
      data.append("return_feedback_hints", "false");

      if (isUpload) {
        filename = await uploadRecordFile(blob);
      }
      axios
        .post(
          "https://api.elsanow.io/api/v2/score_audio",
          data,
          options
        )
        .then((res) => {
          if (user_id) {
            updateAILogs(res.data.total_time, user_id, site_uuid);
          }
          resolve({
            smartCheck: res,
            filename: filename?.data?.id,
          });
        })
        .catch((err) => {
          resolve({
            error: err,
          });
        });
    } catch (err) {}
  });
};

export const audioSmartCheckUnScripted = async (
  blob,
  isUpload = false,
  user_id = null,
  site_uuid
) => {
  const options = {
    headers: {
      Authorization:
        "ELSA DX+gsaRdJgTQN7K3XtShZ5b6x/KnAn7pa7QPf777QVE3phJ46PtdcvN2mGSo5p9YM7JzUOf4idcnCvqwgqaIKHsNmurW+1gfLwv+pZtxBxc=",
    },
    maxContentLength: 100000000,
    maxBodyLength: 1000000000,
  };
  let filename;

  return new Promise(async (resolve, reject) => {
    try {
      const content = await blobToBase64(blob);
      if (isUpload) {
        filename = await uploadRecordFile(blob);
      }

      var data = new FormData();
      data.append("audio_data", content.split("base64,")[1]);
      data.append("api_plan", "premium");
      data.append("force_grammar_vocab", "True");
      data.append("return_json", "true");

      axios
        .post("https://api.elsanow.io/api/v1/score_audio_plus", data, options)
        .then((res) => {
          console.log("res", res);
          if (user_id) {
            updateAILogs(res.data.total_time, user_id, site_uuid);
          }
          resolve({
            smartCheck: res,
            filename: filename?.data?.id,
          });
        })
        .catch((err) => {
          resolve({
            error: err,
          });
        });
    } catch (err) {
      console.log(err);
    }
  });
};

export const blobToBase64 = (blobUrl) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blobUrl);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

//Upload media
export const uploadRecordFile = async (blob) => {
  return new Promise(async (resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.readAsArrayBuffer(blob);
      reader.onload = () => {
        let mp3Worker = new Worker(worker_script);
        const workerUrl = window.location.origin;
        mp3Worker.postMessage({
          arrayBuffer: reader.result,
          link: process.env.REACT_APP_FOR_IPAD == 'true' ? `${process.env.REACT_APP_SERVER_API}/js/lame.min.js`:`${workerUrl}/js/lame.min.js`,
        });

        mp3Worker.onmessage = async (e) => {
          let content1 = await blobToBase64(e.data);
          console.log("SSSSS", content1);
          try {
            let userInfo = Store.getState().loggedInUserInfo.userInfo;
            let usernamesplit = userInfo.username.split("@");
            let data = new FormData();
            data.append("uri", content1);
            data.append("aliasName", usernamesplit[usernamesplit.length - 1]);
            data.append("type", "recording");

            let port = sessionStorage.getItem("port_data")
              ? sessionStorage.getItem("port_data").split(",")
              : process.env.REACT_APP_PORT_DATA.split(",");

            let uri = sessionStorage.getItem("site_ip")
              ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
              : `${process.env.REACT_APP_SERVER_API}:${port[0]}`;

            let config = {
              method: "post",
              maxBodyLength: Infinity,
              url: `${uri}/uploads`,
              headers: {
                "x-access-token": "YRS/DzcxC0+58jfh/kphhA6zz4Y=",
              },
              data: data,
            };

            let response = await axios.request(config).catch((error) => {
              console.log(error);
            });

            // let response = await api
            // .service("uploads")
            // .create(
            //   {
            //     type: "recording",
            //     uri: content1,
            //   },
            //   {}
            // )
            // .catch((err) => {
            //   console.log("DDD", err);
            // });
            console.log("response", response);
            resolve({
              status: 200,
              message: "User-log Created",
              data: response.data,
            });
          } catch (error) {
            console.log("*SDFD**", error);
          }

          mp3Worker.terminate();
        };
      };
      reader.onerror = (error) => reject(error);
    } catch (error) {
      console.log("error", error);
      resolve(error);
    }
  });
};

const updateAILogs = async (usage_time, user_id, site_uuid) => {
  console.log("AD", user_id);
  let response = await api.service("ai-logs").find({
    query: {
      actor: user_id,
      site_uuid: site_uuid,
    },
  });

  let response1;
  console.log("AD", response);
  if (response.data.length == 0) {
    response1 = await api.service("ai-logs").create(
      {
        actor: user_id,
        usage_time: usage_time,
        site_uuid: site_uuid,
      },
      {}
    );
  } else {
    let newTime = +response.data[0]["usage_time"] + +usage_time;
    response1 = await api.service("ai-logs").patch(
      null,
      {
        usage_time: newTime,
      },
      {
        query: {
          actor: user_id,
          site_uuid,
        },
      }
    );
  }

  console.log("!@$$", response1);
};

// Call backend service to get SVG content
export const getSvgContent = async (source) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("get-svg-content").find({
        query: {
          asset: source,
        },
      });

      resolve({
        status: 200,
        message: "SVG Data",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const randomNumber = (range) => {
  return Math.floor(Math.random() * +range);
};

export const generateRandomId = (len) => {
  let charSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let id = "";
  for (let i = 1; i < len; i++) {
    let randPos = Math.floor(Math.random() * charSet.length);
    id += charSet[randPos];
  }
  return id;
};

// Call Internet is available in server or not
export const checkInternet = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("check-internet-service").get(null, {});
      resolve({
        status: 200,
        message: "Internet Availability",
        response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Get latest Customer License
export const getLatestCustomerLicense = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api
        .service("latest-customer-license-info")
        .find(params);
      resolve({
        status: 200,
        message: "Latest Customer Info",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// product update from live
export const productUpdateFromLive = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("product-update-from-live").find(params);
      resolve({
        status: 200,
        message: "Latest Product",
        response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// check product update data in local drive like product.json and it's version
export const verifyProductData = async (data, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api
        .service("add-product-data")
        .patch("", data, params);
      resolve({
        status: 200,
        message: "Product Verify",
        response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// product update from live
export const productUpdateFromLocal = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("add-product-data").find();
      resolve({
        status: 200,
        message: "Latest Product",
        response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Update Defs by params
export const updateDefs = async (data, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("defs").patch(null, data, params);
      resolve({
        status: 200,
        message: "Update Defs",
        response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Sync Database
export const syncDatabase = async (data, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("sync-database").patch(data, params);
      resolve({
        status: 200,
        message: "Sync Data",
        response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Fetch Media
export const fetchMedia = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("media").find(params);
      resolve({
        status: 200,
        message: "media",
        response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Learner check
export const checkLearner = async (belongs_to) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").find({
        query: {
          belongs_to,
          status: true,
          $limit: 1,
        },
      });

      resolve({
        status: 200,
        message: "users",
        response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// File read
export const readFile = async (filename, path) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api
        .service("files-read")
        .get(filename, { query: { fileDirPath: path, isExist: true } });
      resolve({
        status: 200,
        message: "users",
        response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const checkRECADVParams = (checkData, smartcheck) => {
  return checkData.map((val, index) => {
    return {
      word: val.word,
      result: val.check_params.map((val1, index1) => {
        return findOutYourResultFromType(val1, val.index, smartcheck);
      }),
    };
  });
};

export const findOutYourResultFromType = (check_params, index, smartcheck) => {
  if (check_params.type == "stress") {
    let wordResult = smartcheck["utterance"][0]["words"][index];
    if (
      wordResult.word_stress[0] &&
      wordResult.word_stress[0]["stress_level_measured"].toLowerCase() ==
        check_params.value.toLowerCase() &&
      wordResult["decision"] == "correct"
    ) {
      return {
        type: check_params.type,
        result: true,
        expected: check_params.value.toLowerCase(),
        actual:
          wordResult.word_stress[0]["stress_level_measured"].toLowerCase(),
        decision: wordResult["decision"],
      };
    } else {
      return {
        type: check_params.type,
        result: false,
        expected: check_params.value.toLowerCase(),
        actual:
          wordResult.word_stress[0] &&
          wordResult.word_stress[0]["stress_level_measured"]
            ? wordResult.word_stress[0]["stress_level_measured"].toLowerCase()
            : "",
        decision: wordResult["decision"],
      };
    }
  }
};

//Upload media
export const uploadRecordBroadcastFile = async (blobs, aliasName) => {
  return new Promise(async (resolve, reject) => {
    try {
      console.log("blobs", blobs);
      console.log("aliasName",aliasName);
      let files = blobs.map((file) => {
        console.log("file", file);
        const reader = new FileReader();
        return new Promise((resolve1, reject1) => {
          reader.readAsArrayBuffer(file);
          reader.onload = async () => {
            const content1 = await blobToBase64(file);
            resolve1(content1);
          };
          reader.onerror = (error) => reject1(error);
        });
      });

      let res = await Promise.all(files);
      console.log("res===>", res);
      try {
        let data = new FormData();

        data.append("uri", JSON.stringify(res));
        data.append("aliasName", aliasName);
        data.append("type", "broadCast");

        let port = sessionStorage.getItem("port_data")
          ? sessionStorage.getItem("port_data").split(",")
          : process.env.REACT_APP_PORT_DATA.split(",");

        let uri = sessionStorage.getItem("site_ip")
          ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
          : `${process.env.REACT_APP_SERVER_API}:${port[0]}`;

        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${uri}/uploads`,
          headers: {
            "x-access-token": "YRS/DzcxC0+58jfh/kphhA6zz4Y=",
          },
          data: data,
        };

        let response = await axios.request(config).catch((error) => {
          console.log(error);
        });

        console.log("response", response);
        resolve({
          status: 200,
          message: "User-log Created",
          data: response.data,
        });
      } catch (error) {
        console.log("*SDFD**", error);
      }
    } catch (error) {
      console.log("error", error);
      resolve(error);
    }
  });
};
